/* 3D4M site-header interacties.
   Bron: Creaties/Backend/shared/header-footer-inject.js (initHeaderV3).
   Dropdowns (mega-menu), mobiel overlay-menu, dark-mode-toggle, en de
   client-side filament-search-filters (desktop + mobiel). */
(function () {
  function initHeader() {
    // Announcement masthead (Brand identity §18, Variant A) — dismiss met de X.
    // De pre-render <head>-script zet html.announcement-dismissed al voor first paint
    // bij een eerder weggeklikte bar (CSS verbergt dan .masthead-band, geen flash).
    // Klik voegt de class toe + bewaart de keuze in localStorage (blijft weg tot de
    // bezoeker site-data/localStorage wist). Bron: shared/header-footer-inject.js.
    /* Sinds 2026-10-12 niet meer weg te klikken (kruisje verborgen via CSS, Vince): een
       eerder bewaarde keuze opruimen, zodat ook wie hem wegklikte de balk weer ziet. */
    try { localStorage.removeItem('announcement-dismissed'); } catch (e) {}
    document.documentElement.classList.remove('announcement-dismissed');
    var annClose = document.querySelector('.announcement-bar-close');
    if (annClose) {
      annClose.addEventListener('click', function () {
        document.documentElement.classList.add('announcement-dismissed');
        try { localStorage.setItem('announcement-dismissed', '1'); } catch (e) {}
      });
    }

    // Twee theme-toggles kunnen naast elkaar bestaan: het header-icoon (desktop)
    // en de rij in het mobiele overlay. Beide dragen [data-theme-toggle]; de
    // staat wordt afgeleid van document[data-theme] zodat ze synchroon blijven.
    const themeBtns = document.querySelectorAll('[data-theme-toggle]');
    if (themeBtns.length) {
      const syncThemeBtns = (active) => {
        themeBtns.forEach((b) => {
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', String(active));
        });
      };
      if (document.documentElement.getAttribute('data-theme') === 'dark') {
        syncThemeBtns(true);
      }
      themeBtns.forEach((themeBtn) => {
        themeBtn.addEventListener('click', () => {
          const swap = () => {
            const active = document.documentElement.getAttribute('data-theme') !== 'dark';
            if (active) {
              document.documentElement.setAttribute('data-theme', 'dark');
              try { localStorage.setItem('theme', 'dark'); } catch (e) {}
            } else {
              document.documentElement.removeAttribute('data-theme');
              try { localStorage.removeItem('theme'); } catch (e) {}
            }
            syncThemeBtns(active);
          };
          // Niet op de voorpagina van een telefoon (html.own-scroll): Safari liet na de overgang een
          // egaal blok onder de adresbalk staan, waar de 3D-scène hoort door te lopen (Vince 2026-10-13).
          if (document.startViewTransition && !document.documentElement.classList.contains('own-scroll')) {
            document.startViewTransition(swap);
          } else {
            swap();
          }
          if (themeBtn.classList.contains('nav-icon--theme')) {
            themeBtn.classList.remove('is-spinning');
            void themeBtn.offsetWidth;
            themeBtn.classList.add('is-spinning');
          }
        });
      });
    }

    const triggers = document.querySelectorAll('[data-dropdown]');
    const dropdowns = document.querySelectorAll('.nav-dropdown');
    if (!triggers.length) return;

    function closeAll() {
      dropdowns.forEach((d) => d.classList.remove('is-open'));
      triggers.forEach((t) => t.classList.remove('is-open'));
    }
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        const target = document.getElementById(trigger.dataset.dropdown);
        if (!target) return;
        const isOpen = target.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          target.classList.add('is-open');
          trigger.classList.add('is-open');
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.nav-dropdown') || e.target.closest('[data-dropdown]')) return;
      closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    const filSearch = document.getElementById('dd-filaments-search');
    if (filSearch) {
      filSearch.addEventListener('input', function () {
        const q = this.value.toLowerCase().trim();
        let anyColVisible = 0;
        document.querySelectorAll('#dd-filaments .dropdown-col').forEach((col) => {
          const groups = [];
          col.querySelectorAll('.dropdown-col-head').forEach((head) => {
            let items = null;
            for (let n = head.nextElementSibling; n; n = n.nextElementSibling) {
              if (n.classList.contains('dropdown-col-head')) break;
              if (n.classList.contains('dropdown-col-items')) { items = n; break; }
            }
            if (items) groups.push({ head, items });
          });

          let colVisible = 0;
          groups.forEach(({ head, items }) => {
            let groupVisible = 0;
            items.querySelectorAll('.link').forEach((item) => {
              const tokens = item.textContent.toLowerCase().split(/\s+/);
              const match = !q || tokens.some((t) => t.startsWith(q));
              item.style.display = match ? '' : 'none';
              if (match) groupVisible++;
            });
            const hideGroup = groupVisible === 0 && q;
            head.style.display = hideGroup ? 'none' : '';
            items.style.display = hideGroup ? 'none' : '';
            if (!hideGroup) colVisible++;
          });

          const hasUtility = col.querySelector('.dropdown-col-utility');
          col.style.display = (!hasUtility && colVisible === 0 && q) ? 'none' : '';
          if (colVisible > 0) anyColVisible++;
        });

        const empty = document.getElementById('dd-filaments-empty');
        if (empty) empty.hidden = !q || anyColVisible > 0;
      });
    }

    // Mobiel hamburger-menu
    const hamburger = document.getElementById('nav-hamburger');
    const mobileNav = document.getElementById('nav-mobile');
    if (hamburger && mobileNav) {
      // Dicht = display:none, niet alleen buiten beeld geschoven (Vince 2026-10-13). Safari 26
      // kleurt zijn status- en adresbalk naar vaste elementen aan de schermrand, en het gesloten
      // menu buiten beeld telde daarbij mee: na wisselen naar donker in het menu bleef er een
      // licht blok onder de adresbalk staan tot je herlaadde. .is-shown zet het menu op
      // display:block; na het uitschuiven (400ms, de transitie in header-footer-v3.css) gaat
      // die er weer af.
      let navHideTimer = null;
      const setMobileNavOpen = (open) => {
        clearTimeout(navHideTimer);
        if (open) {
          mobileNav.classList.add('is-shown');
          void mobileNav.offsetWidth; // eerst buiten beeld neerzetten, dan schuift 'ie in
        } else {
          navHideTimer = setTimeout(() => mobileNav.classList.remove('is-shown'), 400);
        }
        hamburger.classList.toggle('is-open', open);
        hamburger.setAttribute('aria-expanded', String(open));
        mobileNav.classList.toggle('is-open', open);
        mobileNav.setAttribute('aria-hidden', String(!open));
        document.body.style.overflow = open ? 'hidden' : '';
      };
      hamburger.addEventListener('click', () => {
        setMobileNavOpen(!hamburger.classList.contains('is-open'));
      });
      const closeBtn = document.getElementById('nav-mobile-close');
      if (closeBtn) closeBtn.addEventListener('click', () => setMobileNavOpen(false));

      mobileNav.querySelectorAll('.nav-mobile-link, a.nav-mobile-sub-label, .nav-mobile-cta').forEach((link) => {
        link.addEventListener('click', () => setMobileNavOpen(false));
      });

      // Mobiele accordion — single-open
      mobileNav.querySelectorAll('[data-mobile]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const section = btn.closest('.nav-mobile-section');
          if (!section) return;
          const isOpen = section.classList.contains('is-open');
          mobileNav.querySelectorAll('.nav-mobile-section.is-open').forEach((s) => {
            s.classList.remove('is-open');
            const t = s.querySelector('[data-mobile]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            section.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });

      // Mobiele filament-search — live-filter binnen de open Filaments-kaart
      const mobileSearch = document.getElementById('nav-mobile-search');
      const filSub = document.getElementById('mobile-filaments');
      if (mobileSearch && filSub) {
        const emptyMsg = document.getElementById('nav-mobile-empty');
        const filSection = filSub.closest('.nav-mobile-section');
        const filTrigger = filSection ? filSection.querySelector('[data-mobile]') : null;
        mobileSearch.addEventListener('input', function () {
          const q = this.value.toLowerCase().trim();
          if (q && filSection && !filSection.classList.contains('is-open')) {
            mobileNav.querySelectorAll('.nav-mobile-section.is-open').forEach((s) => {
              s.classList.remove('is-open');
              const t = s.querySelector('[data-mobile]');
              if (t) t.setAttribute('aria-expanded', 'false');
            });
            filSection.classList.add('is-open');
            if (filTrigger) filTrigger.setAttribute('aria-expanded', 'true');
          }
          let anyVisible = 0;
          filSub.querySelectorAll('.nav-mobile-sub-group').forEach((group) => {
            let groupVisible = 0;
            group.querySelectorAll('.nav-mobile-link').forEach((link) => {
              const tokens = link.textContent.toLowerCase().split(/\s+/);
              const match = !q || tokens.some((t) => t.startsWith(q));
              link.style.display = match ? '' : 'none';
              if (match) groupVisible++;
            });
            group.style.display = (groupVisible === 0 && q) ? 'none' : '';
            if (groupVisible > 0) anyVisible++;
          });
          if (emptyMsg) emptyMsg.hidden = !q || anyVisible > 0;
        });
      }
    }
  }

  /* ───────── Winkelwagen-teller (Vince 2026-08-10) ─────────
     Het aantal staat server-side in de header, maar een toevoeging via AJAX herlaadt de
     pagina niet. Deze luisteraar haalt het verse aantal op en zet het in alle voorkomens
     (desktop + mobiel), met een korte uitvergroting zodat de wijziging opvalt.
     Twee bronnen: ons eigen 'cart:updated' (de catalogusrijen) en Dawn's pub/sub, dat de
     productpagina en de cart-drawer gebruiken. */
  function zetCartTeller(aantal) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = aantal;
      el.hidden = !aantal;
      var link = el.closest('.nav-icon');
      if (link) link.setAttribute('aria-label', 'Cart (' + aantal + ')');
      if (!aantal) return;
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 220);
    });
  }
  function ververesCartTeller() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === 'number') zetCartTeller(c.item_count); })
      .catch(function () { /* stil: de teller blijft dan op de server-waarde staan */ });
  }
  document.addEventListener('cart:updated', ververesCartTeller);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, ververesCartTeller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();
